import { FC, useState } from 'react';
import { styled } from '@mui/material/styles';
import { CheckOutlined as Check, CloseOutlined as Close } from '@mui/icons-material';
import { Tooltip } from '@mui/material';
import { Trash } from '../../shared/Assets/svgIcons';

interface DeleteProperties {
	deleteHandler: () => void;
}

const Wrapper = styled('div')<{ removeConfirm: boolean }>((props) => ({
	width: props.removeConfirm ? '40px' : '20px',
	display: 'flex',
	justifyContent: 'space-between',
	cursor: 'pointer',
}));

const Delete: FC<DeleteProperties> = ({ deleteHandler }) => {
	const [removeConfirm, setRemoveConfirm] = useState<boolean>(false);

	const onDelete = () => {
		deleteHandler();
		setRemoveConfirm(false);
	};

	return (
		<Wrapper removeConfirm={removeConfirm}>
			<Tooltip title="Delete">
				{removeConfirm ? (
					<>
						<div onClick={() => setRemoveConfirm(false)}>
							<Close fontSize="small" />
						</div>
						<div onClick={onDelete}>
							<Check fontSize="small" />
						</div>
					</>
				) : (
					<div onClick={() => setRemoveConfirm(true)}>
						<Trash />
					</div>
				)}
			</Tooltip>
		</Wrapper>
	);
};

export default Delete;
